import { Trans } from "react-i18next";
import { useModals } from "src/components/Modals/context/ModalProvider";
import { ModalsNames } from "src/components/Modals/context/modals";
import CommentIcon from "src/images/Icons/newIcons/notifications/comment.svg";

import { TimeComponent } from "../../NewComponents/Default/TimeComponent";
import type { NotificationData } from "./List";
import { Notification } from "./NotificationItem";

interface CommentNotificationProps {
	notification: NotificationData;
	removeNotification: () => Promise<unknown>;
	className?: string;
}

export function CommentNotification({
	notification,
	removeNotification,
	className,
}: CommentNotificationProps) {
	const { openModal } = useModals();
	const redirect = async () => {
		openModal(ModalsNames.QuestionViewModal, {
			questionId: notification.itemId,
			settings: {
				comments: notification.itemId,
			},
		});
	};

	return (
		<Notification
			className={className}
			notification={notification}
			removeNotification={removeNotification}
			onRedirect={redirect}
			Icon={CommentIcon}
			Primary={
				<Trans
					i18nKey="notifications.comment.title"
					values={{ username: notification.username }}
					components={[<strong className="text-black" key="i18Key" />]}
				/>
			}
			Secondary={
				<div className="text-primary size-12 mt-2">
					<TimeComponent
						date={notification.createdAt}
						transKey="notifications.comment.days"
					/>
				</div>
			}
		/>
	);
}
